module.exports = __webpack_public_path__ + "img/crush_brown_natural_ba_detail_rsh.2d7b69e6.jpg";